module.exports = __webpack_public_path__ + "static/media/account_already_exists.c11f2394.svg";